import styled from 'styled-components'
import { DANGER } from '../../styles/colors.style'

const Error = styled.p`
	font-size: 16px;
	color: ${DANGER};
`

export default Error
